<template>
  <div class="carbon">
      <div class="carbon-input">
        <span class="trend-title">排放达标率</span>
        <el-input type="number" placeholder="请输入" v-model="outIndex">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">全年降低碳排放</span>
        <el-input type="number" placeholder="请输入" v-model="lowNum">
          <template slot="suffix">kg</template>
        </el-input>
      </div>
      <!-- 降碳 -->
      <div class="carbon-input">
        <span class="trend-title">生产降碳</span>
        <el-input type="number" placeholder="请输入" v-model="productCarbon">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">绿化降碳</span>
        <el-input type="number" placeholder="请输入" v-model="greenCarbon">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">办公降碳</span>
        <el-input type="number" placeholder="请输入" v-model="officeCarbon">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <div class="carbon-input" style="margin-bottom: 1rem;">
        <span class="trend-title">员工降碳</span>
        <el-input type="number" placeholder="请输入" v-model="userCarbon">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">交通降碳</span>
        <el-input type="number" placeholder="请输入" v-model="carCarbon">
          <template slot="suffix">%</template>
        </el-input>
        <span class="trend-title">楼宇降碳</span>
        <el-input type="number" placeholder="请输入" v-model="floorCarbon">
          <template slot="suffix">%</template>
        </el-input>
      </div>
      <!-- 排放物 -->
      <div class="carbon-input">
        <table class="mytable" style="width:auto">
          <thead>
            <tr>
              <th style="width:200px">排放物</th>
              <th>指标</th>
              <th>去年</th>
              <th>今年</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="background:#203bd5;text-align:center">碳粉层</td>
              <td>
                <el-input v-model="carbonTarger" placeholder="请输入内容">
                  <template slot="suffix">pm</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="carbonDataLast" placeholder="请输入内容">
                  <template slot="suffix">pm</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="carbonData" placeholder="请输入内容">
                  <template slot="suffix">pm</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">二氧化碳</td>
              <td>
                <el-input v-model="dioxideTarget" placeholder="请输入内容">
                  <template slot="suffix">kg</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="dioxideDataLast" placeholder="请输入内容">
                  <template slot="suffix">kg</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="dioxideData" placeholder="请输入内容">
                  <template slot="suffix">kg</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">二氧化硫</td>
              <td>
                <el-input v-model="sulfurTargert" placeholder="请输入内容">
                  <template slot="suffix">t/a</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="sulfurDataLast" placeholder="请输入内容">
                  <template slot="suffix">t/a</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="sulfurData" placeholder="请输入内容">
                  <template slot="suffix">t/a</template>
                </el-input>
              </td>
            </tr>
            <tr>
              <td style="background:#203bd5;text-align:center">氮氧化物</td>
              <td>
                <el-input v-model="nitrogenTarget" placeholder="请输入内容">
                  <template slot="suffix">ppm</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="nitrogenDataLast" placeholder="请输入内容">
                  <template slot="suffix">ppm</template>
                </el-input>
              </td>
              <td>
                <el-input v-model="nitrogenData" placeholder="请输入内容">
                  <template slot="suffix">ppm</template>
                </el-input>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="last-save">
        <el-button :loading="emissLoading" size="small" @click="saveEmiss" type="primary">保存</el-button>
      </div>
  </div>
</template>

<script>
import apis from '@/apis/power/power'
export default {
  data(){
    return{
      emissLoading:false,//加载状态
      linshiID:'',//临时id
      //数据
      outIndex:'',//排放达标率
      lowNum:'',//全年降低碳排放量
      productCarbon:'',//生产降碳
      greenCarbon:'',//绿化降碳
      officeCarbon:'',//办公降碳
      userCarbon:'',//员工降碳
      carCarbon:'',//交通降碳
      floorCarbon:'',//楼宇降碳

      carbonTarger:'',//碳粉层指标
      carbonDataLast:'',//碳粉层上年
      carbonData:'',//碳粉层今年

      dioxideTarget:'',//二氧化碳指标
      dioxideDataLast:'',//二氧化碳上年
      dioxideData:'',//二氧化碳今年

      sulfurTargert:'',//二氧化硫指标
      sulfurDataLast:'',//二氧化硫上年
      sulfurData:'',//二氧化硫今年

      nitrogenTarget:'',//氮氧化物指标
      nitrogenDataLast:'',//氮氧化物上年
      nitrogenData:'',//氮氧化物今年
    }
  },
  mounted(){
    this.getEmiss()
  },
  methods:{
    //获取数据
    getEmiss(){
      apis.getCarbon().then(res=>{
        if(res.code==10000){
          let _this = this
          let _data = res.data.list[0]
          _this.linshiID = _data.id
          _this.outIndex = _data.disStandard
          _this.lowNum = _data.carbonEmission
          _this.productCarbon = _data.proReduct
          _this.greenCarbon = _data.greenReduct
          _this.officeCarbon = _data.workReduct
          _this.userCarbon = _data.staffReduct
          _this.carCarbon = _data.trafficReduct
          _this.floorCarbon = _data.buildingReduct
          //碳粉层
          _this.carbonTarger = _data.carbonTarger
          _this.carbonDataLast = _data.carbonDataLast
          _this.carbonData = _data.carbonData
          //二氧化碳
          _this.dioxideTarget = _data.dioxideTarget
          _this.dioxideDataLast = _data.dioxideDataLast
          _this.dioxideData = _data.dioxideData
          //二氧化硫
          _this.sulfurTargert = _data.sulfurTargert
          _this.sulfurDataLast = _data.sulfurDataLast
          _this.sulfurData = _data.sulfurData
          //氮氧化物
          _this.nitrogenTarget = _data.nitrogenTarget
          _this.nitrogenDataLast = _data.nitrogenDataLast
          _this.nitrogenData = _data.nitrogenData
        }else{
          this.$message.error(res.message);
          return;
        }
      })        
    },
    //保存数据
    saveEmiss(){
      let _that = this
      let obj = {
        //基本信息
        disStandard:_that.outIndex,
        carbonEmission:_that.lowNum,
        proReduct:_that.productCarbon,
        greenReduct:_that.greenCarbon,
        workReduct:_that.officeCarbon,
        staffReduct:_that.userCarbon,
        trafficReduct:_that.carCarbon,
        buildingReduct:_that.floorCarbon,
        //碳粉层
        carbonTarger:_that.carbonTarger,
        carbonDataLast:_that.carbonDataLast,
        carbonData:_that.carbonData,
        //二氧化碳
        dioxideTarget:_that.dioxideTarget,
        dioxideDataLast:_that.dioxideDataLast,
        dioxideData:_that.dioxideData,
        //二氧化硫
        sulfurTargert:_that.sulfurTargert,
        sulfurDataLast:_that.sulfurDataLast,
        sulfurData:_that.sulfurData,
        //氮氧化物
        nitrogenTarget:_that.nitrogenTarget,
        nitrogenDataLast:_that.nitrogenDataLast,
        nitrogenData:_that.nitrogenData,
      }
      if(_that.linshiID){
        obj.id = _that.linshiID
      }
      _that.emissLoading = true
      apis.saveCarbon(obj).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          _that.emissLoading = false
        }else{
          this.$message.error(res.message);
          _that.emissLoading = false
          return;    
        }
      })
    },
  }
}
</script>
<style lang="less" scoped>
.carbon{ padding-top: 10px;
  .carbon-input{ margin-bottom: 15px;
    .trend-title{ width: 8.35rem;}
    .el-input,.el-select{ display: inline-block; width: 12rem;}
  }
}
</style>
